import { Button, Popconfirm } from "antd";

export const getSubjectTableColumns = (onDelete) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (text, record, index) =>
      text || `SUB${(index + 1).toString().padStart(3, "0")}`,
  },
  {
    title: "Subject Name",
    dataIndex: "name",
    key: "name",
    render: (text) => text || "N/A",
  },
  {
    title: "Teacher",
    dataIndex: "teacher",
    key: "teacher",
    render: (text, record) => {
      if (text) return text;
      if (record.teacherName) return record.teacherName;
      if (record.instructor) return record.instructor;
      return "N/A";
    },
  },
  {
    title: "Credits",
    dataIndex: "credits",
    key: "credits",
    render: (text) => text || "0",
  },
  {
    title: "Actions",
    key: "actions",
    render: (record) => (
      <Popconfirm
        title="Are you sure you want to delete this subject?"
        okText="Yes, delete"
        cancelText="Cancel"
        onConfirm={() => onDelete(record.id)}
      >
        <Button danger>Delete</Button>
      </Popconfirm>
    ),
  },
];
